import { controllerValuesEqual } from '../../util/controllerValuesEqual';

const calculateTranscriptionScore = ({
   instrumentRack,
   tempo,
   referenceTempo,
   tempoConfig,
   swing,
   referenceSwing,
   swingConfig,
}) => {
   let tempoWeight = 0;
   let swingWeight = 0;
   let patternWeight = 100;

   const sum = instrumentRack.reduce(
      (acc, instrument) => {
         if (instrument.test === false) {
            return acc;
         }

         let points = 0;
         let referenceCount = 0;
         instrument.referencePattern.forEach((notes, i) => {
            const noteLengthMap = {};
            notes.forEach(({ note, noteLength }) => {
               noteLengthMap[note] = noteLength;
               referenceCount += 1;
            });
            instrument.pattern[i].forEach(({ note, noteLength }) => {
               if (!Object.prototype.hasOwnProperty.call(noteLengthMap, note)) {
                  points -= 1;
               } else if (noteLengthMap[note] === noteLength) {
                  points += 1;
               } else {
                  points += 0.5;
               }
            });
         });
         return {
            referenceCount: acc.referenceCount + referenceCount,
            points: acc.points + points,
         };
      },
      { referenceCount: 0, points: 0 }
   );
   let patternScore = sum.points / sum.referenceCount;

   if (tempoConfig.display) {
      tempoWeight = 10;
      patternWeight -= tempoWeight;
   }
   const tempoScore = Math.max(0, 15 - Math.abs(tempo - referenceTempo)) / 15;

   if (swingConfig.display) {
      swingWeight = 10;
      patternWeight -= swingWeight;
   }
   const swingScore = controllerValuesEqual(swing, referenceSwing) ? 1 : 0;

   if (sum.referenceCount === 0) {
      tempoWeight *= swingConfig.display ? 5 : 10;
      swingWeight *= tempoConfig.display ? 5 : 10;
      patternWeight = 0;
      patternScore = 0;
   }

   return Math.round(
      patternScore * patternWeight +
         tempoScore * tempoWeight +
         swingScore * swingWeight
   );
};

export { calculateTranscriptionScore };
